// This file manages exports from the base atom, molecule, or organism.

export { MapComponent } from './MapComponent';

// Use named rather than default exports.
